<div class="badge required">
    <span class="label">{{ 'admin.strain.sample-boards.details.tabs.documentation.registryItems.requiredLabel' | translate }}</span>
    <span class="value">{{ item?.requiredQuantity || 0 }}</span>
</div>
<div class="badge spare">
    <span class="label">{{ 'admin.strain.sample-boards.details.tabs.documentation.registryItems.spareLabel' | translate }}</span>
    <span class="value">{{ item?.spareQuantity || 0 }}</span>
</div>
<div class="registry-name">{{ displayName }}</div>
<a class="registry-action waves-effect btn-flat"
   (click)="onOpenRegistry($event)">
    <i class="material-icons">open_in_new</i>
</a>
